import React from "react";
import { View, Text } from "react-native";
import Modal from 'react-native-modal';

import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";
import AppStyles from "../../AppStyles";
import Colors from "../constants/AppColors";

class AddCartItemToast extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            showToast: props.showToast,
            bottomMargin: props.bottomMargin,
            toastText: 'Item added to cart'
        };
    }

    componentDidMount() {
        if (this.state.showToast) {
            var popUpTimer = setTimeout(() => {
                this.props.closeToast()
                clearTimeout(popUpTimer);
            }, AppTheme.animationDuration);
        }
    }

    render() {
        return <Modal isVisible={this.state.showToast}
            backdropOpacity={0} hasBackdrop={true}
            onBackdropPress={() => this.props.closeToast()}>
            <View style={[AppStyles.bottomFix, AppStyles.alignCenter,
            AppStyles.borderView, {
                margin: "auto", width: AppTheme.appWidth - 48,
                backgroundColor: Colors.grey.darkBg,
                paddingVertical: 8, paddingHorizontal: 16,
                bottom: this.state.bottomMargin
            }]}>
                <Text style={[TextStyle.text12, {
                    color: Colors.white, flexWrap: "wrap",
                    textAlign: "center"
                }]}>{this.state.toastText}</Text>
            </View>
        </Modal>
    }
}

export default AddCartItemToast